import AuthLayout from '../layout/AuthLayout';
import { Navigate } from 'react-router-dom';
import Curriculum from '../pages/curriculum';
import CreateItem from '../pages/curriculum/create';
import EditItem from '../pages/curriculum/edit';
import Lesson from '../pages/lesson';
import CreateLesson from '../pages/lesson/create';
import EditLesson from '../pages/lesson/edit';
import VideoList from '../pages/video';
import CreateVideo from '../pages/video/create';
import EditVideo from '../pages/video/edit';
import QuizList from '../pages/quiz';
import CreateQuiz from '../pages/quiz/create';
import EditQuiz from '../pages/quiz/edit';
import EditQuizQuestions from '../pages/quiz/questions';
import MenuList from '../pages/menu';
import CreateMenu from '../pages/menu/create';
import EditMenu from '../pages/menu/edit';
import CategoryList from '../pages/category';
import CreateCategory from '../pages/category/create';
import EditCategory from '../pages/category/edit';
import PostList from '../pages/post';
import CreatePost from '../pages/post/create';
import EditPost from '../pages/post/edit';
import ConfigList from '../pages/config';
import CreateConfig from '../pages/config/create';
import EditConfig from '../pages/config/edit';
import UserList from '../pages/user';
import CreateUser from '../pages/user/create';
import EditUser from '../pages/user/edit';
import QuizAttemptsList from '../pages/quiz_attempts';

// routes
const UserRoutes = [
  {
    path: '/',
    element: <Navigate to="/cms/quan-ly-hoc-vien" replace />,
  },
  {
    path: 'cms',
    element: <AuthLayout></AuthLayout>,
    children: [
      {
        path: 'quan-ly-chuong-trinh',
        element: <Curriculum />,
      },
      {
        path: 'quan-ly-chuong-trinh/them-chuong-trinh',
        element: <CreateItem />,
      },
      {
        path: 'quan-ly-chuong-trinh/sua-chuong-trinh/:id',
        element: <EditItem />,
      },
      {
        path: 'quan-ly-bai-hoc',
        element: <Lesson />,
      },
      {
        path: 'quan-ly-bai-hoc/them-bai-hoc',
        element: <CreateLesson />,
      },
      {
        path: 'quan-ly-bai-hoc/sua-bai-hoc/:id',
        element: <EditLesson />,
      },
      {
        path: 'quan-ly-de-on-tap',
        element: <QuizList />,
      },
      {
        path: 'quan-ly-de-on-tap/them-de-on-tap',
        element: <CreateQuiz />,
      },
      {
        path: 'quan-ly-de-on-tap/sua-de-on-tap/:id',
        element: <EditQuiz />,
      },
      {
        path: 'quan-ly-de-on-tap/sua-cau-hoi/:id',
        element: <EditQuizQuestions />,
      },
      {
        path: 'quan-ly-video',
        element: <VideoList />,
      },
      {
        path: 'quan-ly-video/them-video',
        element: <CreateVideo />,
      },
      {
        path: 'quan-ly-video/sua-video/:id',
        element: <EditVideo />,
      },
      {
        path: 'quan-ly-menu',
        element: <MenuList />,
      },
      {
        path: 'quan-ly-menu/them-menu',
        element: <CreateMenu />,
      },
      {
        path: 'quan-ly-menu/sua-menu/:id',
        element: <EditMenu />,
      },
      {
        path: 'quan-ly-danh-muc',
        element: <CategoryList />,
      },
      {
        path: 'quan-ly-danh-muc/them-danh-muc',
        element: <CreateCategory />,
      },
      {
        path: 'quan-ly-danh-muc/sua-danh-muc/:id',
        element: <EditCategory />,
      },
      {
        path: 'quan-ly-bai-viet',
        element: <PostList />,
      },
      {
        path: 'quan-ly-bai-viet/them-bai-viet',
        element: <CreatePost />,
      },
      {
        path: 'quan-ly-bai-viet/sua-bai-viet/:id',
        element: <EditPost />,
      },
      {
        path: 'quan-ly-cau-hinh',
        element: <ConfigList />,
      },
      {
        path: 'quan-ly-cau-hinh/them-cau-hinh',
        element: <CreateConfig />,
      },
      {
        path: 'quan-ly-cau-hinh/sua-cau-hinh/:id',
        element: <EditConfig />,
      },
      {
        path: 'quan-ly-hoc-vien',
        element: <UserList />,
      },
      {
        path: 'quan-ly-hoc-vien/them-hoc-vien',
        element: <CreateUser />,
      },
      {
        path: 'quan-ly-hoc-vien/sua-hoc-vien/:id',
        element: <EditUser />,
      },
      {
        path: 'quan-ly-lich-su-on-bai',
        element: <QuizAttemptsList />,
      },
    ],
  },
];

export { UserRoutes };
